import { AxiosInstance } from 'axios';

import { DeleteItemsInput, SizeTable, SizeTables } from '../../types';
import { sizeTablesEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { CreateSizeTableInput } from './SizeTablesApi.schema';

export class SizeTablesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getAllSizeTables = async (): Promise<Partial<SizeTables>> => {
    return this.#requestInstance.get(sizeTablesEndpoints.sizeTables);
  };

  getSizeTableById = async (id: string): Promise<SizeTable> => {
    return this.#requestInstance.get(sizeTablesEndpoints.getSizeTableById(id));
  };

  create = async (table: CreateSizeTableInput): Promise<SizeTable> => {
    return this.#requestInstance.post(sizeTablesEndpoints.sizeTables, table);
  };

  update = async (table: SizeTable): Promise<SizeTable> => {
    return this.#requestInstance.patch(sizeTablesEndpoints.getSizeTableById(table.id), table);
  };

  deleteSizeTable = async (input: string): Promise<void> => {
    return this.#requestInstance.delete(sizeTablesEndpoints.getSizeTableById(input));
  };

  deleteManyTables = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(sizeTablesEndpoints.sizeTables, { data: input });
  };
}

export const sizeTablesApi = new SizeTablesApi(axios);
